import useTLO from "./useTLO"

export default function useComparableDealAsset(id) {
  return useTLO("sale_asset", id)
}
